document.addEventListener('DOMContentLoaded', function() {
  const hideMenuItemOnDesktop = () => {
    const desktopBreakpoint = 750; // The pixel width to consider as 'desktop'

    // Only run this script on desktop-sized screens.
    if (window.innerWidth >= desktopBreakpoint) {
      // Find all menu item text spans in the desktop menu.
      const menuItems = document.querySelectorAll('header-menu .mega-menu__link-title');

      menuItems.forEach(item => {
        // Check if the text content matches "View Collections".
        if (item.textContent.trim() === 'View Collections') {
          // Find the parent list item (<li>) and hide it completely.
          const listItem = item.closest('li');
          if (listItem) {
            listItem.style.display = 'none';
          }
        }
      });
    }
  };

  // Run the function as soon as the page is ready.
  hideMenuItemOnDesktop();
});